const IconFileText = ({ className }) => {
    return (
        <svg viewBox='0 0 37 38' xmlns='http://www.w3.org/2000/svg' className={className}>
            <path
                d='M21.5834 3.58203V12.832H30.8334M24.6667 20.5404H12.3334M24.6667 26.707H12.3334M22.3542 3.58203H9.25002C8.43227 3.58203 7.64801 3.90688 7.06977 4.48512C6.49154 5.06336 6.16669 5.84761 6.16669 6.66536V31.332C6.16669 32.1498 6.49154 32.934 7.06977 33.5123C7.64801 34.0905 8.43227 34.4154 9.25002 34.4154H27.75C28.5678 34.4154 29.352 34.0905 29.9303 33.5123C30.5085 32.934 30.8334 32.1498 30.8334 31.332V12.0612L22.3542 3.58203Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconFileText;
